export interface IPictureFeedbackState {
  [pictureId: string]: {
    feedback?: string;
    feedback_id?: string;
  };
}

export const initialPictureFeedbackState: IPictureFeedbackState = {};
